import { FitCcBaseModel } from './fit-cc-base-model'


export interface FitCcBaseSerializer {
    fromJson(json: any[]): FitCcBaseModel[];
    toJson(base: FitCcBaseModel, isNew: Boolean): any;
}

